import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation, input, output } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
    selector: 'fcp-popover',
    standalone: true,
    imports: [CommonModule, PopoverModule],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        <p-popover
            #popoverRef
            [appendTo]="appendTo()"
            [autoZIndex]="autoZIndex()"
            [baseZIndex]="baseZIndex()"
            [ariaCloseLabel]="ariaCloseLabel()"
            [dismissable]="dismissable()"
            [focusOnShow]="focusOnShow()"
            [ariaLabel]="ariaLabel()"
            [ariaLabelledBy]="ariaLabelledBy()"
            [showTransitionOptions]="showTransitionOptions()"
            [hideTransitionOptions]="hideTransitionOptions()"
            (onShow)="onShow.emit($event)"
            (onHide)="onHide.emit($event)"
        >
            <ng-content></ng-content>
        </p-popover>
    `
})
export class FcpPopOverComponent {
    e2e = input<string | null>(null);
    appendTo = input<HTMLElement | string>('body');
    autoZIndex = input<boolean>(true);
    baseZIndex = input<number>(0);
    ariaCloseLabel = input<string | null>(null);
    dismissable = input<boolean>(true);
    focusOnShow = input<boolean>(true);
    ariaLabel = input<string | null>(null);
    ariaLabelledBy = input<string | null>(null);
    showTransitionOptions = input<string>('.12s cubic-bezier(0, 0, 0.2, 1)');
    hideTransitionOptions = input<string>('.1s linear');

    onShow = output<Event>();
    onHide = output<Event>();

    @ViewChild('popoverRef') popoverRef: Popover | undefined;

    getOverlayElement(): HTMLElement | null {
        return this.popoverRef?.container ?? null;
    }

    show(event: Event, target?: HTMLElement): void {
        this.popoverRef?.show(event, target);
    }

    hide(): void {
        this.popoverRef?.hide();
    }

    toggle(event: Event, target?: HTMLElement): void {
        this.popoverRef?.toggle(event, target);
    }
}
